import {createRoutesFromChildren, matchRoutes, RouterProvider, useLocation, useNavigationType} from "react-router-dom";
import routers from "./routers";

import * as Sentry from "@sentry/react";
import {useEffect} from "react";
import APP_PACKAGE from "../package.json";

Sentry.init({
    dsn: "https://ddf7d30f2f26ebe47a92faea10cbab29@sentry.vnetwork.dev/11",
    integrations: [
        // See docs for support of different versions of variation of React router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    environment: import.meta.env.VITE_APP_ENV,
    release: `build-${APP_PACKAGE.version}.${import.meta.env.VITE_APP_ENV}`,
    // Performance Monitoring
    tracesSampleRate: import.meta.env.VITE_APP_ENV === 'development' ? 0.1 : 1.0, //  Capture 100% of the transactions

    // Session Replay
    replaysSessionSampleRate: import.meta.env.VITE_APP_ENV === 'production' ? 1.0 : 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: import.meta.env.VITE_APP_ENV === 'production'
});

const App = () => {
    return <RouterProvider router={routers}/>;
};

export default App;
